export enum PolicyStatus {
  Cancelled,
  Inforce,
  Inactive,
  Scheduled,
  Other,
  PendingCancel,
  Expired
}
